import { ENROLMENT_FORM_SECTIONS } from '@pages/enrolment/constants.js';

const enrolmentSectionComponents = {
  'applicant-details': () => import('@pages/enrolment/forms/applicant-details.vue'),
  'contact-household': () => import('@pages/enrolment/forms/contact-household.vue'),
  'employment-education': () => import('@pages/enrolment/forms/employment-education.vue'),
  'sign-and-confirm': () => import('@pages/enrolment/forms/sign-and-confirm.vue'),
  'marketing-options': () => import('@pages/enrolment/forms/marketing-options.vue'),
  'residency-and-id': () => import('@pages/enrolment/forms/residency-and-id.vue'),
};

const enrolmentSectionRoutes = ENROLMENT_FORM_SECTIONS.map(section => ({
  path: section.id,
  name: section.routeName,
  component: enrolmentSectionComponents[section.id],
  meta: {
    title: 'Enrolment Form',
    sectionId: section.id,
    sectionNumber: section.sectionNumber,
    public: false,
  },
}));

const enrolmentStatusRoute = {
  path: 'status',
  name: 'enrolment-status',
  component: () => import('@pages/enrolment/submission-status-page.vue'),
  meta: {
    title: 'Enrolment Form',
    public: false,
  },
};

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@pages/auth/login-page.vue'),
    is_public: true,
    meta: { title: 'Sign in' },
  },
  {
    path: '/',
    component: () => import('@layouts/default-layout.vue'),
    children: [
      {
        path: '',
        name: 'hub',
        component: () => import('@pages/hub/hub-page.vue'),
        meta: { title: 'Hub', public: false },
      },
      {
        path: 'hub',
        redirect: { name: 'hub' },
      },
      {
        path: 'enrolment',
        name: 'enrolment',
        component: () => import('@pages/enrolment/enrolment-page.vue'),
        meta: { title: 'Enrolment Form', public: false },
        children: [...enrolmentSectionRoutes, enrolmentStatusRoute],
      },
      {
        path: 'documents',
        name: 'documents',
        component: () => import('@pages/documents-review/documents-page.vue'),
        meta: { title: 'Documents', public: false },
        children: [
          {
            path: '',
            redirect: { name: 'apprenticeship-agreement' },
          },
          {
            path: 'apprenticeship-agreement',
            name: 'apprenticeship-agreement',
            component: () => import('@pages/documents-review/apprenticeship-agreement.vue'),
            meta: { title: 'Compliance documents', public: false },
          },
        ],
      },
      {
        path: 'apprenticeship-agreement',
        redirect: { name: 'apprenticeship-agreement' },
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@pages/profile/profile-page.vue'),
        meta: { title: 'Profile', public: false },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@layouts/default-layout.vue'),
    children: [
      {
        path: '',
        name: 'not-found',
        component: () => import('@pages/not-found-page.vue'),
        meta: { title: 'Page not found' },
      },
    ],
  },
];

export default routes;
